import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';


/**
 * Component principal de la aplicación
 */
@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  /**
   * Título de la aplicación
   */
  title = 'Rapid Score';
  akanaTitle = 'Akana | Tu informe de salud financiera';

  /**
   * Crea una instancia para app component.
   * @param router 
   */
  constructor(
    @Inject(DOCUMENT) private _document: HTMLDocument,
    private router: Router,
    private titleService: Title
    ) {
  }

  /**
   * on init
   */
  ngOnInit() {
    this.redirectToCarousel();
    if (window.location.href.toLowerCase().includes('rapidscore')) {
      this.titleService.setTitle(this.title);
      console.log(this._document.getElementById('favIcon'));
      this._document.getElementById('favIcon').setAttribute('href', './assets/icons/santander.ico');
    } else {
      this._document.getElementById('favIcon').setAttribute('href', './assets/icons/akana.ico');
      this.titleService.setTitle(this.akanaTitle);
    }
  }

  /**
   * redirect to terms view if _actionHide exists
   */
  redirectToCarousel() {
    if (this.getAction('_actionHide')) {
      this.router.navigateByUrl('terms');
    }
  }
  /**
   * Devuelve elemento del storage
   * @param action 
   * @returns  
   */
  getAction(action) {
    return sessionStorage.getItem(action);
  }
}
